import { render } from "./LoginStoreView.vue?vue&type=template&id=b5253cc8"
import script from "./LoginStoreView.vue?vue&type=script&lang=js"
export * from "./LoginStoreView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__